import serviceRequest from "utils/request";

const baseUrl = "/api/information";
const agreementRequestCache = new Map();
const AGREEMENT_CACHE_TTL = 5 * 60 * 1000;

const normalizeAgreementData = (data = {}) =>
	Object.keys(data)
		.sort()
		.reduce((result, key) => {
			if (data[key] !== undefined && data[key] !== null) {
				result[key] = data[key];
			}
			return result;
		}, {});

const getCachedAgreementRequest = (cacheKey, request) => {
	const cached = agreementRequestCache.get(cacheKey);
	if (cached && Date.now() - cached.createdAt < AGREEMENT_CACHE_TTL) {
		return cached.promise;
	}

	const promise = request().catch((error) => {
		agreementRequestCache.delete(cacheKey);
		throw error;
	});
	agreementRequestCache.set(cacheKey, { createdAt: Date.now(), promise, response: null });
	promise.then((response) => {
		const cached = agreementRequestCache.get(cacheKey);
		if (cached?.promise === promise) {
			cached.response = response;
		}
	});
	return promise;
};

export const getCachedAgreementResponse = (kind, data) => {
	const cached = agreementRequestCache.get(`${kind}:${JSON.stringify(normalizeAgreementData(data))}`);
	return cached && Date.now() - cached.createdAt < AGREEMENT_CACHE_TTL ? cached.response : null;
};

export const clearAgreementRequestCache = () => {
	agreementRequestCache.clear();
};

export const getParamInfo = (data) => {
	return serviceRequest({
		url: `${baseUrl}/v2/get-param`,
		method: "post",
		data,
	});
};

export const getMaintenanceNoticeForAdmin = () => {
	return serviceRequest({
		url: `${baseUrl}/important-note-for-maintenance`,
		method: "get",
	});
};

export const updateMaintenanceNotice = (data) => {
	return serviceRequest({
		url: `${baseUrl}/important-note-for-maintenance`,
		method: "put",
		data,
	});
};

export const getParamInfoNotLogin = (data) => {
	return serviceRequest({
		url: `${baseUrl}/get-param-not-login`,
		method: "post",
		data,
	});
};

export const getLoginiconsInfo = () => {
	return serviceRequest({
		url: `${baseUrl}/v2/get-loginicons`,
		method: "post",
	});
};

export const getByTypeInfo = (data) => {
	return serviceRequest({
		url: `${baseUrl}/v2/get-by-type`,
		method: "post",
		data,
	});
};

export const getByTypeInfoNotLogin = (data) => {
	return serviceRequest({
		url: `${baseUrl}/get-by-type-not-login`,
		method: "post",
		data,
	});
};

export const getByAgreementType = (data) => {
	return getCachedAgreementRequest(`type:${JSON.stringify(normalizeAgreementData(data))}`, () =>
		serviceRequest({
			url: `${baseUrl}/v2/get-by-agreement-type`,
			method: "post",
			data,
		})
	);
};

export const getServiceAgreement = (data) => {
	return getCachedAgreementRequest(`service:${JSON.stringify(normalizeAgreementData(data))}`, () =>
		serviceRequest({
			url: `${baseUrl}/get-service-agreement`,
			method: "post",
			data,
		})
	);
};

export const getByAgreementTypeNotLogin = (data) => {
	return serviceRequest({
		url: `${baseUrl}/get-by-agreement-type-not-login`,
		method: "post",
		data,
	});
};

export const getNotesByType = (params) => {
	return serviceRequest({
		url: `${baseUrl}/get-notes-by-type`,
		method: "get",
		params,
	});
};

export const getImportantMaintenance = () => {
	return serviceRequest({
		url: `${baseUrl}/get-important-note-for-maintenance`,
		method: "post",
	});
};

export const getSignedUndertaking = (data) => {
	return serviceRequest({
		url: `${baseUrl}/get-signed-agreement`,
		method: "post",
		data,
	});
};
